var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramNeutral = function SvgTelegramNeutral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.66 4.234c-.307-.27-.79-.31-1.288-.101-.525.218-14.845 6.595-15.428 6.855-.106.039-1.033.397-.937 1.196.085.72.83 1.019.92 1.053l3.64 1.294c.242.835 1.133 3.915 1.33 4.573.123.41.323.949.674 1.06.307.123.614.01.812-.151l2.226-2.144 3.593 2.91.085.053q.366.168.701.168.26 0 .496-.1c.538-.23.754-.763.776-.823l2.684-14.483c.164-.773-.064-1.167-.284-1.36M10.78 15.049l-1.228 3.4-1.229-4.25 9.416-7.225z"
  })));
};
export { SvgTelegramNeutral as ReactComponent };